// MerchantView.jsx

import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const AmlPepScreeningView = props => {
    const { data = {} } = props;
    const { amlPepRefEntities, ...restData } = data || {};

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">Aml Pep Screening Section Data</h1>
                <div className="">
                    {amlPepRefEntities && Object.keys(amlPepRefEntities || {}).length > 0 ? (
                        <div className="table-container" style={{ marginBottom: '20px' }}>
                            <table
                                className="checker-table"
                                border="1"
                                cellPadding="5"
                                cellSpacing="5"
                                style={{ width: '100%' }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: 'bold' }}>Reference Type</th>
                                        <th style={{ fontWeight: 'bold' }}>Entity ID</th>
                                        <th style={{ fontWeight: 'bold' }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(amlPepRefEntities).map(([referenceType, entities]) =>
                                        Array.isArray(entities) && entities.length > 0 ? (
                                            entities.map((entity, idx) => (
                                                <tr key={`${referenceType}-${idx}`}>
                                                    <td>{referenceType}</td>
                                                    <td>{entity?.entityId || '-'}</td>
                                                    <td>{entity?.status || '-'}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr key={`${referenceType}-empty`}>
                                                <td>{referenceType}</td>
                                                <td>-</td>
                                                <td>-</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : null}
                </div>
                <div className="form-section">
                    <GetValuesRender data={restData} isNestedRenderingAllowed />
                </div>
            </div>
        </>
    );
};

AmlPepScreeningView.propTypes = {
    data: PropTypes.object,
    auth: PropTypes.object,
};

export default AmlPepScreeningView;
